import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

// Zwraca Set<shelter_id> dla schronisk, ktore maja aktywna pilna zbiorke
// LUB aktywna pilna adopcje (is_urgent=true i nie wygaslo - 90 dni od urgent_set_at).
// Razem z isUrgentNeedsActive(shelter) tworzy logike OR dla filtra "Pilne sprawy"
// oraz dla pomaranczowych markerow na mapie.
const URGENT_TTL_DAYS = 90;

const cutoffIso = () => {
  const d = new Date();
  d.setDate(d.getDate() - URGENT_TTL_DAYS);
  return d.toISOString();
};

export const useSheltersWithUrgentSection = () => {
  return useQuery({
    queryKey: ["shelters-with-urgent-section"],
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<Set<string>> => {
      const cutoff = cutoffIso();
      const [fundRes, adoptRes] = await Promise.all([
        supabase
          .from("shelter_fundraiser")
          .select("shelter_id,urgent_set_at")
          .eq("is_urgent", true)
          .or(`urgent_set_at.is.null,urgent_set_at.gte.${cutoff}`),
        supabase
          .from("shelter_adoptions")
          .select("shelter_id,urgent_set_at")
          .eq("is_urgent", true)
          .or(`urgent_set_at.is.null,urgent_set_at.gte.${cutoff}`),
      ]);
      if (fundRes.error) throw new Error(fundRes.error.message);
      if (adoptRes.error) throw new Error(adoptRes.error.message);
      const set = new Set<string>();
      (fundRes.data ?? []).forEach((r: { shelter_id: string }) => set.add(r.shelter_id));
      (adoptRes.data ?? []).forEach((r: { shelter_id: string }) => set.add(r.shelter_id));
      return set;
    },
  });
};
